export default function LoadingPage() {
  return (
    <div className="app-layout">
      <main className="app-main" style={{ textAlign: 'center', padding: '4rem' }}>
        <div className="spinner" />
      </main>
    </div>
  )
}
